import { useState } from "react";
import { X } from "lucide-react";
import "./Navbar.css";
import LanguageDropdown from "./LanguageDropdown";

function Navbar() {
  const [open, setOpen] = useState(false);

  const isActive = (path) => window.location.pathname === path;

  const closeMenu = () => {
    setOpen(false);
  };

  return (
    <nav
      className="navbar-main"
      style={{
        background: open ? "#00000047" : "",
        height: open ? "100vh" : "",
      }}
    >
      <div className="nav-container">
        {/* LEFT LOGOS */}
        <div className="nav-left">
          {open ? (
            <div className="mobile-logos">
              <a href="/" className="logo-link">
                <img
                  src="/assets/Tns-logo.svg"
                  className="mobile-tns-logo"
                  alt="TNS Global"
                />
              </a>

              <img
                src="/assets/Sabre-logo-footer.svg"
                className="mobile-sabre-logo"
                alt="Sabre"
              />
            </div>
          ) : (
            <div className="desktop-logos">
              <a href="/" className="logo-link">
                <img
                  src="/assets/nav-tns-logo.svg"
                  className="tns-logo"
                  alt="TNS Global"
                />
              </a>

              <img
                src="/assets/Sabre-logo.svg"
                className="tns-logo"
                alt="Sabre"
              />
            </div>
          )}
        </div>

        {/* DARK OVERLAY */}
        {open && <div className="sidebar-overlay" onClick={closeMenu} />}

        {/* NAVIGATION / SIDEBAR */}
        <ul className={`nav-links ${open ? "open" : ""}`}>
          {/* HOME */}
          <li>
            <a
              href="/"
              className={isActive("/") ? "active" : ""}
              onClick={closeMenu}
            >
              Home
            </a>
          </li>

          {/* WHY TNS & SABRE */}
          <li>
            <a
              href="/why-tns-sabre"
              className={isActive("/why-tns-sabre") ? "active" : ""}
              onClick={closeMenu}
            >
              Why TNS & Sabre
            </a>
          </li>

          {/* RESOURCES */}
          <li>
            <a
              href="/resources"
              className={isActive("/resources") ? "active" : ""}
              onClick={closeMenu}
            >
              Resources
            </a>
          </li>

          {/* CONTACT */}
          <li>
            <a
              href="/contact-us"
              className={isActive("/contact-us") ? "active" : ""}
              onClick={closeMenu}
            >
              Contact
            </a>
          </li>

          {/* EXPLORE SABRE */}
          <li>
            <a
              href="https://www.sabre.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="explore-link"
            >
              Explore Sabre
            </a>
          </li>

          {/* LANGUAGE */}
          <LanguageDropdown />

          {/* MOBILE CONTACT DETAILS */}
          <div className="mobile-contact-info">
            <div className="mobile-divider"></div>

            <div className="contact-item">
              <img src="/assets/nav-phn.svg" alt="" />
              <span>971-058-627-9149</span>
            </div>

            <div className="contact-item">
              <img src="/assets/nav-whatsapp.svg" alt="" />
              <span>(+971)-058-6279155</span>
            </div>

            <div className="contact-item">
              <img src="/assets/nav-mail.svg" alt="" />
              <span>connect@tnsglobal.co</span>
            </div>
          </div>
        </ul>

        {/* HAMBURGER / CLOSE */}
        <button
          className="menu-toggle"
          onClick={() => setOpen((prev) => !prev)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? (
            <X />
          ) : (
            <>
              <span className="hamburger-line line-1"></span>
              <span className="hamburger-line line-2"></span>
              <span className="hamburger-line line-3"></span>
            </>
          )}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
